import { environment } from '../../environments/environment';
import stakingAbiJson from './staking-abi.json';
import { parseAbi } from 'viem';

export const CONTRACT_ADDRESSES = {
  LOONY_STAKING: environment.LOONY_STAKING_ADDRESS, 
  LOONY_TOKEN: environment.LOONY_TOKEN_ADDRESS,
};

export const STAKING_ABI = stakingAbiJson;

export const TOKEN_ABI = parseAbi([
  'function approve(address spender, uint256 amount) returns (bool)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function balanceOf(address account) view returns (uint256)',
  'function decimals() view returns (uint8)'
]);
